/**
 * Created by mykurisu on 2017/8/21.
 */
import React from 'react'
import {renderMoney, TimeStream} from '../../utils'
import OtherIncome from '../../images/wallet/liveroom-other-income-icon .png'
import Income from '../../images/wallet/liveroom-income-icon.png'
import Promote from '../../images/wallet/liveroom-promote-income-icon.png'
import Withdraw from '../../images/wallet/liveroom-withdraw-icon.png'
import scheduleImg from '../../images/wallet/schedule.png'
import ShareIncome from '../../images/wallet/wallet_share_income.png'
import PgyImg from '../../images/wallet/icon-pgy.png'

class WalletDetailListItem extends React.Component {

    renderIcon() {
        const {walletListItem} = this.props;
        switch (walletListItem.type) {
            case 'reward':
            case 'pay_lecture':
            case 'pay_channel':
            case 'gift_lecture':
            case 'gift_channel':
            case 'reward_commission':
            case 'relay':
            case 'liveroom_vip':
            case 'pay_lecture_lecturerpercent':
            case 'pay_channel_lecturerpercent':
            case 'relay_channel':
                return Income;
            case 'subscribe_relay':
            case 'pay_lecture_relay':
            case 'pay_channel_relay':
            case 'liveroom_vip_resell':
            case 'pay_lecture_promote':
            case 'pay_channel_promote':
            case 'pay_lecture_resell':
            case 'pay_channel_resell':
            case 'pay_lecture_resell1':
            case 'pay_channel_resell1':
            case 'supermember_resell':
            case 'supermember_resell1':
                return Promote;
            case 'withdraw':
                return Withdraw;
            case 'pay_schedule':
            case 'schedule_bonus':
            case 'schedule_bp_carve':
                return scheduleImg;
            case 'couponbag_rebate':
                return ShareIncome;
            case 'pgy_pay_channel':
                return PgyImg
            default:
                return OtherIncome
        }
    }

    renderMoneyIn() {
        const {walletListItem} = this.props;
        if (walletListItem.change > 0) {
            return (
                <div className="item-num">
                    {'+' + renderMoney(walletListItem.change)}
                </div>
            )
        } else {
            return (
                <div className="item-num item-num-black">
                    {renderMoney(walletListItem.change)}
                </div>
            )
        }
    }

    render() {
        const {walletListItem} = this.props;
        return (
            <div className="wallet-detail-listitem">
                <div className="item-left">
                    <div className="item-left-icon">
                        <img src={this.renderIcon()} alt=""/>
                    </div>
                    <div className="item-left-info">
                        {walletListItem.type === 'withdraw' ?
                            <div className="info-title">{walletListItem.name}</div>
                            :
                            <div className="info-title">
                                {walletListItem.description === '' ? walletListItem.name : walletListItem.description}
                            </div>
                        }
                        {walletListItem.type === 'withdraw' &&
                        <div style={{marginTop: '-10px', marginBottom: '4px', color: '#999'}}>{walletListItem.description}</div>
                        }
                        <div className="info-time">
                            {walletListItem.create_time || TimeStream(walletListItem.create_timestamp)}
                        </div>
                    </div>
                    {this.renderMoneyIn()}
                </div>
            </div>
        )
    }
}

export default  WalletDetailListItem



// WEBPACK FOOTER //
// ./src/components/wallet/WalletDetailListItem.js